import React, { Fragment, useEffect, useContext, useState } from 'react';
import { Redirect, Route, useLocation } from 'wouter';
import { AuthContext } from "../contexts/auth";
import AuthLayout from './AuthLayout';
import Swal from 'sweetalert2';
import { hasPermission } from '../utils';


const AuthenticatedRoute = ({ component: Component, permission, ...rest }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [, setLocation] = useLocation();
  const { token, profile } = useContext(AuthContext);


  useEffect(() => {
    if (token) {
      setIsAuthenticated(true);
    } else {
      setLocation('/login');
    }
  }, [token]);

  
  if (isAuthenticated) {
    if (!hasPermission(permission, profile)) {
      if (profile?.customer_type === 'employee') {
        return <Redirect to="/areariservata/not_allowed" />;
      } else {
        Swal.fire({
          icon: "warning",
          title: "Sottoscrizione richiesta",
          html: `
            É necessaria la sottoscrizione ad un piano di abbonamento per utilizzare la risorsa richiesta.</br></br> 
            Scopri le nuove funzionalità di Consultala HR cliccando 
            <b style="color: #4338ca; text-decoration: underline;">
              <a href="https://consultalahr.com/" target="_blank" style="color: inherit; text-decoration: inherit;">
                qui
              </a>
            </b>.
          `,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'Vai ai piani',
          showCancelButton: true,
          cancelButtonText: 'Annulla',
        }).then((result) => {
          if (result.isConfirmed) {
            setLocation("/livelli");
          } else {
            setLocation("/");
          }
        });
      }
    }
  }

  return (
    <Route {...rest}>
      {isAuthenticated && (
        <AuthLayout>
          <Component {...rest} />
        </AuthLayout>
      ) }
    </Route>
  );
};

export default AuthenticatedRoute;